// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BodyPanel {
    width: 1200px;
    /* height:730px; */
    border: 1px solid;
    border-radius: 5px;
    position: relative;
    top: 500px;
    left: 100px;
    padding: 30px;
    box-sizing: border-box;
    background-color: white;
    z-index: 0;
    box-shadow: 3px 3px 10px 5px #6b6b6b;
}


.pagetitle {
    color: white;
    margin-top: 200px;
    margin-left: 22vw;
    font-weight: bolder;
    font-size: 25px;
    position: absolute;
    display: block;
    text-align: center; 
}


.firstpara {
    display: flex;
    flex-direction: row;
    background-color: white;
    
    font-size: larger;
    border-radius: 5px;
    width: 80%;
    left: 135px;
    position: relative;
    top: 350px;
    text-align: justify;
    padding: 20px;
    height: -moz-fit-content;
    height: fit-content;
    word-wrap: break-word;
    align-items: center;
}

.thirdpara {
    color: white;
    border-radius: 25px;
    width: 80%;
    left: 130px;
    position: relative;
   top: 570px;
   text-align: justify;
   padding: 20px;
   font-size: larger;
}


#stlviewer {
    margin-top: -350px;
}

.secondpara {
    padding-right: 50px;
    flex: 1 1;
}

.second {
    height: 350px;
    width: 300px;
    margin-left: 520px;
    background-color: white;
    margin-top: -350px;
    position: relative;
    box-shadow: 3px 3px 5px 2px #6b6b6b;
}

.third {
    height: 350px;
    width: 300px;
    background-color: white;
    position: relative;
    box-shadow: 3px 3px 5px 2px #6b6b6b;
    margin-left: 200px;
    margin-top: 35px;
}

canvas {
    height: 350px;
    position: relative;
}

.first {
    margin-top: -200px;
    height: 350px;
    width: 873px;
    margin-top: 10px;
    background-color: white;
    position: relative;
}

.last {
    height: 350px;
    width: 990px;
    margin-left: 400px;
    top: 400px;
    background-color: white;
    position: relative;
    border-radius: 25px;
    box-shadow: 3px 3px 5px 5px #e8e8e8;
}

.stlselect {
    margin-left: 400px;
    margin-top: 250px;
}

.uploadfile {
    background-color: white;
    height: 350px;
    margin-top: 10px;
    width: 873px;
    border-radius: 10px;
    border-color: #c9c9c9;
    position: relative;

}

.uploadfilenew {
    background-color: white;
    height: 350px;
    margin-top: 10px;
    width: 873px;
    border-radius: 10px;
    border-color: #c9c9c9;
}

.uploadbutton {
    background-color: #D50C2F;
    color: white;
    border-radius: 25px;
    border-color: #D50C2F;
    width: 70px;
    height: 30px;
    margin-top: 10px;
}

#message {
    width: 240px;
}

.uploadiconpopup {
    padding-bottom: 20px;
}

.uploadiconpopup:hover, .uploadbutton {
    cursor: pointer;
}

.previewheading {
    margin-top: -20px;
    color: #D50C2F;
    font-weight: bold;
    font-size: medium;
    float: center;
    position: relative;

}

.previewheadingnew {
    margin-top: -20px;
    color: #D50C2F;
    font-weight: bold;
    font-size: small;
    float: left;
    margin-left: 247px;
    position: relative;
}

.previewheadingnew2 {
    margin-top: -20px;
    color: #D50C2F;
    font-weight: bold;
    font-size: small;
    float: left;
    margin-left: -13px;
    position: relative;
}

.previewheading2 {
    margin-top: -20px;
    color: #D50C2F;
    font-weight: bold;
    font-size: small;
    float: left;
    margin-left: 530px;
    position: relative;
}

.resultsheading {
    margin-top: -22px;
    color: #D50C2F;
    font-weight: bold;
    font-size: small;
    float: left;
    margin-left: 852px;
    position: relative;
}

@media screen and (max-width: 1300px) {
    .previewheadingnew{
        margin-left: 167px;
        font-size: x-small;
    }
}

@media screen and (max-width: 1300px) {
    .previewheadingnew2{
        font-size: x-small;
    }
}

@media screen and (max-width: 1300px) {
    .previewheading2 {
        margin-left: 350px;
        font-size: x-small;
    }
}

@media screen and (max-width: 1300px) {
     .resultsheading{
        margin-left: 610px;
        font-size: x-small;
    }
}


@media screen and (max-width: 900px) {
    .firstpara{
       flex-direction: column;
   }
}



.compare {
    color: #D50C2F;
    text-align: left;
    font-weight: bold;
    padding-bottom: 20px;
}

.boundingbox {
    text-align: left;
    /* flex-direction: inherit;
    display: flex; */
    display: -webkit-inline-box;
    padding-left: 10px;
    margin-right: 10px;
}

.submitform {
    background-color: #D50C2F;
    border-radius: 25px;
    width: 150px;
    height: 35px;
    border: 1px;
    color: white;
}

#submit {
    padding-top: 20px;
}

input {
    width: 100px;
    background-color: #F0F0F1;
    border-color: white;
    
}

select {
    width: 100px;
    background-color: #F0F0F1;
    
}

.previewtable {
    float: left;
    padding-right: 15px;
}

.preview1 {
    width: 1140px;
    height:450px;
    margin-top: -490px;
    position: relative;
    border: 1px solid;
    border-radius: 5px;
    border-color: #c9c9c9;
    position: absolute;
    padding: 30px;
    box-sizing: border-box;
    background-color: #c9c9c9;
    box-shadow: 3px 3px 5px 5px #e8e8e8;
    /* box-shadow: black; */
}

th {
    font-size: small;
  
}

.preview {
    width: 230px;
    height:350px;
    margin-top: -469px;
    margin-left: 870px;
    border: 1px solid;
    border-color: #c9c9c9;
    position: absolute;
    padding: 30px;
    box-sizing: border-box;
    background-color: white;
    overflow-y: auto;
    overflow-x: hidden;
    box-shadow: 3px 3px 5px 2px #6b6b6b;
    /* box-shadow: black; */
}

.previewfirst {
    overflow: hidden;
}

.previewnew {
    width: 180px;
    height:350px;
    border: 1px solid;
    border-color: #c9c9c9;
    position: absolute;
    padding: 30px;
    box-sizing: border-box;
    background-color: white;
    overflow-y: auto;
    overflow-x: hidden;
    box-shadow: 3px 3px 5px 2px #6b6b6b;
    top: 65px;
    /* box-shadow: black; */
}

@media screen and (max-width: 1300px) {
    .BodyPanel{
        width: 900px;
        left: 15vw;
    }
}

@media screen and (max-width: 1100px) {
    .BodyPanel{
        left: 10vw;
    }
}

@media screen and (max-width: 1100px) {
    .firstpara, .lastpara{
        left: 10vw !important;
    }
}

@media screen and (max-width: 1000px) {
    .BodyPanel{
        left: 5vw;
    }
}

@media screen and (max-width: 900px) {
    .BodyPanel{
        left: 30px;
    }
}

@media screen and (max-width: 1100px) {
    .stpimg{
        left: 3%;
    }
}

@media screen and (max-width: 1000px) {
    .stpimg{
        left: 5%;
    }
}

@media screen and (max-width: 900px) {
    .stpimg{
        left: 6%;
    }
}

@media screen and (max-width: 900px) {
    .stpimg{
        left: 8%;
        margin-top: 0;
    }
}

@media screen and (max-width: 700px) {
    .stpimg{
        left: 10%;
    }
}

@media screen and (max-width: 600px) {
    .stpimg{
        left: 12%;
    }
}

@media screen and (min-width: 1800px) {
    .stpimg{
        left: -3%;
    }
}



@media screen and (max-width: 1500px) {
    .lastpara{
        margin-top: 100px;
    }
}

@media screen and (min-width: 1500px) {
    .lastpara{
        margin-top: 100px;
    }
}

@media screen and (min-width: 1700px) {
    .lastpara{
        margin-top: 1px;
    }
}


@media screen and (min-width: 1300px) {
    .BodyPanel{
        margin-left: 25px;
    }
}

@media screen and (min-width: 1400px) {
    .BodyPanel{
        margin-left: 70px;
    }
}


@media screen and (min-width: 1400px) {
    .chartlist{
        margin-left: 0px !important;
    }
}



@media screen and (min-width: 1600px) {
    .firstpara, .lastpara{
        left: 180px !important;
    }
}



@media screen and (min-width: 1500px) {
    .BodyPanel{
        align-items: center;
        left: 150px;
    }
}

@media screen and (min-width: 1600px) {
    .BodyPanel{
        left: 190px;
    }
}

/* @media screen and (max-width: 1500px) {
    .BodyPanel{
        top: 1800px;
    }
} */

@media screen and (min-width: 1700px) {
    .BodyPanel{
        align-items: center;
        left: 265px;
    }
}

@media screen and (min-width: 1300px) {
    .firstpara, .lastpara{
       margin-left: 2%;
    }
}

@media screen and (min-width: 1700px) {
    .firstpara, .lastpara{
       margin-left: 7%;
    }
}

@media screen and (min-width: 1900px) {
    .firstpara, .lastpara{
       margin-left: 11%;
    }
}


@media screen and (min-width: 1900px) {
    .BodyPanel{
        align-items: center;
        left: 355px;
    }
}

@media screen and (min-width: 2000px) {
    .BodyPanel{
        left: 385px;
    }
}


/* 
@media screen and (max-width: 1300px) {
    .accordion-button, .accordion-body{
        width: 700px;
    }
} */

@media screen and (max-width: 1300px) {
    .accordion-button, .accordion-body{
        margin-left: 10px;
    }
}

@media screen and (max-width: 1300px) {
    .preview1 {
        width: 92%;
    }
}

@media screen and (max-width: 1300px) {
    .accordion {
        width: 900px;
    }
}

@media screen and (max-width: 1300px) {
      .second,canvas {
        width: 27%;
    }
}

@media screen and (max-width: 1300px) {
    .first {
      width: 100%;
  }
}

@media screen and (max-width: 1300px) {
    .second{
      margin-left: 355px;
   }
}

@media screen and (max-width: 1300px) {
    .listheading{
      left: 12px;
   }
}

@media screen and (max-width: 1300px) {
    .filesbody{
      left: 10px;
   }
}

@media screen and (max-width: 1300px) {
    .previewnew{
      width: 16%;
   }
}

@media screen and (max-width: 1300px) {
    .preview{
      margin-left: 600px;
      width: 200px;
   }
}

@media screen and (max-width: 1300px) {
    .third {
       width: 27%;
       margin-left: 140px;
   }
}

 @media screen and (min-width: 2101px) {
    .third {
       width: 29%;
   }
}

@media screen and (min-width: 2101px) {
    .second{
      margin-left: 46%;
      width: 29%;
      position: absolute;
      top: 415px;  
   }
}

@media screen and (min-width: 2101px) {
    .preview{
      margin-left: 75%;
      width: 18%;
      top: 575px;
   }
}

@media screen and (min-width: 2101px) {
    .previewheading2{
      margin-left: 35%;
   }
}

@media screen and (min-width: 2101px) {
    .resultsheading{
      margin-left: 85%;
   }
}


@media screen and (min-width: 2101px) {
    .BodyPanel{
        max-width: 60%;
       margin-left: 3.6% !important;
    }
}

@media screen and (min-width: 1500px) {
    .BodyPanel{
       margin-left: 2% !important;
    }
}

@media screen and (min-width: 1800px) {
    .BodyPanel{
        margin-left: 3% !important;
    }
}


@media screen and (min-width: 2301px) {
    .BodyPanel{
      
       margin-left: 4.2% !important;
    }
}

@media screen and (min-width: 2101px) {
    .preview1 {
        width: 95%;
    }
}

@media screen and (min-width: 2101px) {
    .first{
        width: 100%;
    }
}

@media screen and (min-width: 2101px) {
    .uploadfile{
        width: 95%;
    }
} 

@media screen and (min-width: 1300px) {
    .chartlist{
        margin-left: -30px;
    }
}


@media screen and (max-width: 1300px) {
    .chartlist{
        margin-left: 50px;
    }
} 

@media screen and (min-width: 1500px) {
    .chartlist{
        margin-left: 1% !important;
    }
} 

@media screen and (min-width: 1600px) {
    .chartlist{
        margin-left: 3.5% !important;
    }
} 


@media screen and (min-width: 1700px) {
    .chartlist{
        margin-left: 9% !important;
    }
} 



@media screen and (min-width: 1900px) {
    .chartlist{
        margin-left: 250px !important;
    }
} 


@media screen and (min-width: 2101px) {
    .chartlist{
        margin-left: 13% !important;
    }
} 

@media screen and (max-width: 1100px) {
    .chartlist{
        margin-left: 0px;
    }
} 

@media screen and (max-width: 1300px) {
    .accordion{
        width: 900px !important;
    }
} 


@media screen and (max-width: 1100px) {
    .accordion{
        margin-left: 100px !important;
    }
} 

@media screen and (max-width: 1000px) {
    .accordion{
        margin-left: 100px !important;
    }
} 

@media screen and (max-width: 1000px) {
    .accordion, .chartlist{
        margin-left: 20px !important;
    }
} 

@media screen and (max-width: 880px) {
    .accordion{
        margin-left: 0px !important;
    }
} 

@media screen and (max-width: 750px) {
    .pagetitle{
        margin-top: 250px;
        margin-left: 350px;
    }
} 

@media screen and (max-width: 750px) {
    .chartlist{
        left: 7px;
    }
} 

@media screen and (max-width: 750px) {
    .firstpara, .thirdpara, .lastpara{
        margin-left: 40px;
    }
} 

@media screen and (max-width: 750px) {
    .stpimg{
        margin-left: 100px;
    }
} 

@media screen and (max-width: 700px) {
    .pagetitle{
        margin-top: 250px;
        margin-left: 380px;
    }
} 

@media screen and (max-width: 700px) {
    .chartlist{
        left: 10px;
    }
} 

@media screen and (max-width: 700px) {
    .firstpara, .thirdpara, .lastpara{
        margin-left: 90px;
    }
} 

@media screen and (max-width: 700px) {
    .stpimg{
        margin-left: 200px;
    }
} 

@media screen and (min-width: 1700px) {
    .lastpara{
        margin-top: 100px;
    }
} 

@media screen and (min-width: 1600px) {
    .BodyPanel, .chartlist{
        margin-left: 3%;
    }
}

/* @media screen and (min-width: 1570px) {
    .stpimg{
      margin-top: -10px !important;
    
    }
} */

/* @media screen and (max-width: 1550px) {
    .stpimg{
        margin-top: 2% !important;
    
    }
} */

@media screen and (min-width: 1500px) {
    .firstpara{
        max-width: 1200px;
    
    }}



.partidbutton {
    width: 100px;
    height: 40px;
    float: left;
    font-size: x-small;
    padding-bottom: 10px;
    text-overflow: ellipsis;
    overflow: hidden;
    border: 2px solid #D50C2F;
    border-radius: 15px;
    background-color: white;
    margin-bottom: 5px;
    margin-left: 30px;
    padding-top: 10px;
} 

.fileslist {
    width: 100px;
    float: left;
    font-size: x-small;
    padding-bottom: 10px;
    text-overflow: ellipsis;
    overflow: hidden;
    border: 2px solid #D50C2F;
    border-radius: 15px;
    background-color: white;
    margin-bottom: 5px;
    padding-top: 10px;
}

.fileslist:hover {
    cursor: pointer;
    background-color: #D50C2F;
    color: white;
}


.partidbutton4 {
    width: 100px;
    float: left;
    font-size: x-small;
    padding-bottom: 10px;
    text-overflow: ellipsis;
    overflow: hidden;
    border: 2px solid #D50C2F;
    border-radius: 15px;
    background-color: #D50C2F;
    margin-bottom: 5px;
    margin-left: 5px;
    padding-top: 10px;
    color: white;
} 

.partidbutton4:hover {
    cursor: pointer;
}

.partidbutton3 {
    width: 100px;
    height: 40px;
    float: left;
    font-size: x-small;
    padding-bottom: 10px;
    text-overflow: ellipsis;
    overflow: hidden;
    border: 2px solid #D50C2F;
    border-radius: 15px;
    background-color: #D50C2F;
    margin-bottom: 5px;
    margin-left: 30px;
    padding-top: 10px;
    color: white;
} 

.partidbutton3:hover {
    cursor: pointer;
}



.partidbutton2 {
    width: 100px;
    height: 35px;
    float: left;
    font-size: xx-small;
    padding-bottom: 10px;
    text-overflow: ellipsis;
    overflow: hidden;
    border: none;
    margin-bottom: 5px;
    color: #D50C2F;
} 


.partidbutton1 {
    width: 60px;
    height: 35px;
    float: right;
    font-size: xx-small;
    padding-bottom: 10px;
    text-overflow: ellipsis;
    overflow: hidden;
    border: 2px solid #D50C2F;
    border-radius: 15px;
    background-color: white;
    margin-bottom: 5px;
    position: relative;
    left: -30px;
} 


.sim {
    position: relative;
    left: -30px;
}

table,  td {
    align-items: center;
    width: 131%;  
}
 td {
    padding-right: 20px;

}

svg {
    width: -webkit-fill-available;
    height: 70px;
    color: #D50C2F;
}

.accordion-item {
    border-radius: 25px;
}

.accordion {
    margin-top: 500px;
    padding-bottom: 10px;
    position: relative;
    width: 1200px;
    margin-left: 160px;
}

/* Style the buttons that are used to open and close the accordion panel */
.accordion-button {
    background-color: #D50C2F;
    color: white;
    cursor: pointer;
    padding: 18px;
    min-inline-size: -webkit-fill-available;
    text-align: center;
    border: none;
    outline: none;
    transition: 0.4s;
    font-weight: bold;
    border-radius: 10px;
    position: relative;
    z-index: 0;
    font-size: large;
  }
  
  /* Add a background color to the button if it is clicked on (add the .active class with JS), and when you move the mouse over it (hover) */
  .active {
    background-color: #c9c9c9;
  }



  .accordion-body {
    padding-top: 40px;
    margin-top: -45px;
    background-color: white;
    height: 600px;
  }

  
  /* Style the accordion panel. Note: hidden by default */
  .panel {
    padding: 0 18px;
    border: 1px solid;
    display: none;
    overflow: hidden;
  }


.calculationmethod {
  border-radius: 5px;
  height: 30px;
  width: 145px;
}

button.partidbutton:active {
    background-color: #D50C2F;
    border-color: #D50C2F;
    color: white;
}

.partidbutton:hover, .submitform:hover, .uploadfile:hover {
    cursor: pointer;
}


.partidbutton:hover {
   overflow-x: visible;
    overflow-wrap: normal;
    width: 200px;
    margin-right: 25px;
    border: none;
    color: #D50C2F;
    font-size: xx-small;
    margin-left: -20px;
}

.uploadiconpopup1 {
    margin-top: 15%;
}

.spacer {
    height: 20px;
}


.stpimg {
    width:45%;
    flex-shrink: 0;
    height: max-content;
    
}



.lastpara {
    background-color: white;
    border-radius: 5px;
    width: 80%;
    left: 130px;
    position: relative;
   top: 50px;
   text-align: justify;
   padding: 20px;
   font-size: larger;
   z-index: 0;
   max-width: 1200px;
}

.listheading {
  position: absolute;
 margin-left: 27px;
 padding-bottom: 20px;
}

.filesbody {
    top: 50px;
    position: absolute;
}
/* 
.chartlist {
    background-color: white;
    width: 1200px;
    margin-left: 180px;
    height: 1200px;
    border-radius: 25px;
} */

.chartlist {
    margin-top: 650px !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,oCAAoC;AACxC;;;AAGA;IACI,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,aAAa;IACb,wBAAmB;IAAnB,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,kBAAkB;GACnB,UAAU;GACV,mBAAmB;GACnB,aAAa;GACb,iBAAiB;AACpB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,SAAO;AACX;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;;AAEtB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,kBAAkB;;AAEtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI;QACI,kBAAkB;QAClB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,kBAAkB;IACtB;AACJ;;AAEA;KACK;QACG,kBAAkB;QAClB,kBAAkB;IACtB;AACJ;;;AAGA;IACI;OACG,sBAAsB;GAC1B;AACH;;;;AAIA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB;oBACgB;IAChB,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;;AAEvB;;AAEA;IACI,YAAY;IACZ,yBAAyB;;AAE7B;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,mCAAmC;IACnC,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;;AAEpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,mCAAmC;IACnC,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,mCAAmC;IACnC,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI;QACI,YAAY;QACZ,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;;;AAIA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;;AAGA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;;AAGA;IACI;QACI,2BAA2B;IAC/B;AACJ;;;;AAIA;IACI;QACI,sBAAsB;IAC1B;AACJ;;;;AAIA;IACI;QACI,mBAAmB;QACnB,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;;;;GAIG;;AAEH;IACI;QACI,mBAAmB;QACnB,WAAW;IACf;AACJ;;AAEA;IACI;OACG,eAAe;IAClB;AACJ;;AAEA;IACI;OACG,eAAe;IAClB;AACJ;;AAEA;IACI;OACG,gBAAgB;IACnB;AACJ;;;AAGA;IACI;QACI,mBAAmB;QACnB,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;;AAGA;;;;;GAKG;;AAEH;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;MACM;QACE,UAAU;IACd;AACJ;;AAEA;IACI;MACE,WAAW;EACf;AACF;;AAEA;IACI;MACE,kBAAkB;GACrB;AACH;;AAEA;IACI;MACE,UAAU;GACb;AACH;;AAEA;IACI;MACE,UAAU;GACb;AACH;;AAEA;IACI;MACE,UAAU;GACb;AACH;;AAEA;IACI;MACE,kBAAkB;MAClB,YAAY;GACf;AACH;;AAEA;IACI;OACG,UAAU;OACV,kBAAkB;GACtB;AACH;;CAEC;IACG;OACG,UAAU;GACd;AACH;;AAEA;IACI;MACE,gBAAgB;MAChB,UAAU;MACV,kBAAkB;MAClB,UAAU;GACb;AACH;;AAEA;IACI;MACE,gBAAgB;MAChB,UAAU;MACV,UAAU;GACb;AACH;;AAEA;IACI;MACE,gBAAgB;GACnB;AACH;;AAEA;IACI;MACE,gBAAgB;GACnB;AACH;;;AAGA;IACI;QACI,cAAc;OACf,4BAA4B;IAC/B;AACJ;;AAEA;IACI;OACG,0BAA0B;IAC7B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;;AAGA;IACI;;OAEG,4BAA4B;IAC/B;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;;AAGA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,4BAA4B;IAChC;AACJ;;;AAGA;IACI;QACI,0BAA0B;IAC9B;AACJ;;;;AAIA;IACI;QACI,6BAA6B;IACjC;AACJ;;;AAGA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;;AAGA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;;;;;GAKG;;AAEH;;;;;GAKG;;AAEH;IACI;QACI,iBAAiB;;IAErB,CAAC;;;;AAIL;IACI,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,YAAY;AAChB;;;AAGA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;;;AAIA;IACI,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;;AAGA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;CACC;IACG,mBAAmB;;AAEvB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;;AAEA,0EAA0E;AAC1E;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,uCAAuC;IACvC,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;EAClB;;EAEA,0IAA0I;EAC1I;IACE,yBAAyB;EAC3B;;;;EAIA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,aAAa;EACf;;;EAGA,uDAAuD;EACvD;IACE,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,gBAAgB;EAClB;;;AAGF;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;;AAGA;GACG,mBAAmB;IAClB,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,SAAS;IACT,cAAc;IACd,mBAAmB;;AAEvB;;;;AAIA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,kBAAkB;GACnB,SAAS;GACT,mBAAmB;GACnB,aAAa;GACb,iBAAiB;GACjB,UAAU;GACV,iBAAiB;AACpB;;AAEA;EACE,kBAAkB;CACnB,iBAAiB;CACjB,oBAAoB;AACrB;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;AACA;;;;;;;GAOG;;AAEH;IACI,4BAA4B;AAChC","sourcesContent":[".BodyPanel {\n    width: 1200px;\n    /* height:730px; */\n    border: 1px solid;\n    border-radius: 5px;\n    position: relative;\n    top: 500px;\n    left: 100px;\n    padding: 30px;\n    box-sizing: border-box;\n    background-color: white;\n    z-index: 0;\n    box-shadow: 3px 3px 10px 5px #6b6b6b;\n}\n\n\n.pagetitle {\n    color: white;\n    margin-top: 200px;\n    margin-left: 22vw;\n    font-weight: bolder;\n    font-size: 25px;\n    position: absolute;\n    display: block;\n    text-align: center; \n}\n\n\n.firstpara {\n    display: flex;\n    flex-direction: row;\n    background-color: white;\n    \n    font-size: larger;\n    border-radius: 5px;\n    width: 80%;\n    left: 135px;\n    position: relative;\n    top: 350px;\n    text-align: justify;\n    padding: 20px;\n    height: fit-content;\n    word-wrap: break-word;\n    align-items: center;\n}\n\n.thirdpara {\n    color: white;\n    border-radius: 25px;\n    width: 80%;\n    left: 130px;\n    position: relative;\n   top: 570px;\n   text-align: justify;\n   padding: 20px;\n   font-size: larger;\n}\n\n\n#stlviewer {\n    margin-top: -350px;\n}\n\n.secondpara {\n    padding-right: 50px;\n    flex: 1;\n}\n\n.second {\n    height: 350px;\n    width: 300px;\n    margin-left: 520px;\n    background-color: white;\n    margin-top: -350px;\n    position: relative;\n    box-shadow: 3px 3px 5px 2px #6b6b6b;\n}\n\n.third {\n    height: 350px;\n    width: 300px;\n    background-color: white;\n    position: relative;\n    box-shadow: 3px 3px 5px 2px #6b6b6b;\n    margin-left: 200px;\n    margin-top: 35px;\n}\n\ncanvas {\n    height: 350px;\n    position: relative;\n}\n\n.first {\n    margin-top: -200px;\n    height: 350px;\n    width: 873px;\n    margin-top: 10px;\n    background-color: white;\n    position: relative;\n}\n\n.last {\n    height: 350px;\n    width: 990px;\n    margin-left: 400px;\n    top: 400px;\n    background-color: white;\n    position: relative;\n    border-radius: 25px;\n    box-shadow: 3px 3px 5px 5px #e8e8e8;\n}\n\n.stlselect {\n    margin-left: 400px;\n    margin-top: 250px;\n}\n\n.uploadfile {\n    background-color: white;\n    height: 350px;\n    margin-top: 10px;\n    width: 873px;\n    border-radius: 10px;\n    border-color: #c9c9c9;\n    position: relative;\n\n}\n\n.uploadfilenew {\n    background-color: white;\n    height: 350px;\n    margin-top: 10px;\n    width: 873px;\n    border-radius: 10px;\n    border-color: #c9c9c9;\n}\n\n.uploadbutton {\n    background-color: #D50C2F;\n    color: white;\n    border-radius: 25px;\n    border-color: #D50C2F;\n    width: 70px;\n    height: 30px;\n    margin-top: 10px;\n}\n\n#message {\n    width: 240px;\n}\n\n.uploadiconpopup {\n    padding-bottom: 20px;\n}\n\n.uploadiconpopup:hover, .uploadbutton {\n    cursor: pointer;\n}\n\n.previewheading {\n    margin-top: -20px;\n    color: #D50C2F;\n    font-weight: bold;\n    font-size: medium;\n    float: center;\n    position: relative;\n\n}\n\n.previewheadingnew {\n    margin-top: -20px;\n    color: #D50C2F;\n    font-weight: bold;\n    font-size: small;\n    float: left;\n    margin-left: 247px;\n    position: relative;\n}\n\n.previewheadingnew2 {\n    margin-top: -20px;\n    color: #D50C2F;\n    font-weight: bold;\n    font-size: small;\n    float: left;\n    margin-left: -13px;\n    position: relative;\n}\n\n.previewheading2 {\n    margin-top: -20px;\n    color: #D50C2F;\n    font-weight: bold;\n    font-size: small;\n    float: left;\n    margin-left: 530px;\n    position: relative;\n}\n\n.resultsheading {\n    margin-top: -22px;\n    color: #D50C2F;\n    font-weight: bold;\n    font-size: small;\n    float: left;\n    margin-left: 852px;\n    position: relative;\n}\n\n@media screen and (max-width: 1300px) {\n    .previewheadingnew{\n        margin-left: 167px;\n        font-size: x-small;\n    }\n}\n\n@media screen and (max-width: 1300px) {\n    .previewheadingnew2{\n        font-size: x-small;\n    }\n}\n\n@media screen and (max-width: 1300px) {\n    .previewheading2 {\n        margin-left: 350px;\n        font-size: x-small;\n    }\n}\n\n@media screen and (max-width: 1300px) {\n     .resultsheading{\n        margin-left: 610px;\n        font-size: x-small;\n    }\n}\n\n\n@media screen and (max-width: 900px) {\n    .firstpara{\n       flex-direction: column;\n   }\n}\n\n\n\n.compare {\n    color: #D50C2F;\n    text-align: left;\n    font-weight: bold;\n    padding-bottom: 20px;\n}\n\n.boundingbox {\n    text-align: left;\n    /* flex-direction: inherit;\n    display: flex; */\n    display: -webkit-inline-box;\n    padding-left: 10px;\n    margin-right: 10px;\n}\n\n.submitform {\n    background-color: #D50C2F;\n    border-radius: 25px;\n    width: 150px;\n    height: 35px;\n    border: 1px;\n    color: white;\n}\n\n#submit {\n    padding-top: 20px;\n}\n\ninput {\n    width: 100px;\n    background-color: #F0F0F1;\n    border-color: white;\n    \n}\n\nselect {\n    width: 100px;\n    background-color: #F0F0F1;\n    \n}\n\n.previewtable {\n    float: left;\n    padding-right: 15px;\n}\n\n.preview1 {\n    width: 1140px;\n    height:450px;\n    margin-top: -490px;\n    position: relative;\n    border: 1px solid;\n    border-radius: 5px;\n    border-color: #c9c9c9;\n    position: absolute;\n    padding: 30px;\n    box-sizing: border-box;\n    background-color: #c9c9c9;\n    box-shadow: 3px 3px 5px 5px #e8e8e8;\n    /* box-shadow: black; */\n}\n\nth {\n    font-size: small;\n  \n}\n\n.preview {\n    width: 230px;\n    height:350px;\n    margin-top: -469px;\n    margin-left: 870px;\n    border: 1px solid;\n    border-color: #c9c9c9;\n    position: absolute;\n    padding: 30px;\n    box-sizing: border-box;\n    background-color: white;\n    overflow-y: auto;\n    overflow-x: hidden;\n    box-shadow: 3px 3px 5px 2px #6b6b6b;\n    /* box-shadow: black; */\n}\n\n.previewfirst {\n    overflow: hidden;\n}\n\n.previewnew {\n    width: 180px;\n    height:350px;\n    border: 1px solid;\n    border-color: #c9c9c9;\n    position: absolute;\n    padding: 30px;\n    box-sizing: border-box;\n    background-color: white;\n    overflow-y: auto;\n    overflow-x: hidden;\n    box-shadow: 3px 3px 5px 2px #6b6b6b;\n    top: 65px;\n    /* box-shadow: black; */\n}\n\n@media screen and (max-width: 1300px) {\n    .BodyPanel{\n        width: 900px;\n        left: 15vw;\n    }\n}\n\n@media screen and (max-width: 1100px) {\n    .BodyPanel{\n        left: 10vw;\n    }\n}\n\n@media screen and (max-width: 1100px) {\n    .firstpara, .lastpara{\n        left: 10vw !important;\n    }\n}\n\n@media screen and (max-width: 1000px) {\n    .BodyPanel{\n        left: 5vw;\n    }\n}\n\n@media screen and (max-width: 900px) {\n    .BodyPanel{\n        left: 30px;\n    }\n}\n\n@media screen and (max-width: 1100px) {\n    .stpimg{\n        left: 3%;\n    }\n}\n\n@media screen and (max-width: 1000px) {\n    .stpimg{\n        left: 5%;\n    }\n}\n\n@media screen and (max-width: 900px) {\n    .stpimg{\n        left: 6%;\n    }\n}\n\n@media screen and (max-width: 900px) {\n    .stpimg{\n        left: 8%;\n        margin-top: 0;\n    }\n}\n\n@media screen and (max-width: 700px) {\n    .stpimg{\n        left: 10%;\n    }\n}\n\n@media screen and (max-width: 600px) {\n    .stpimg{\n        left: 12%;\n    }\n}\n\n@media screen and (min-width: 1800px) {\n    .stpimg{\n        left: -3%;\n    }\n}\n\n\n\n@media screen and (max-width: 1500px) {\n    .lastpara{\n        margin-top: 100px;\n    }\n}\n\n@media screen and (min-width: 1500px) {\n    .lastpara{\n        margin-top: 100px;\n    }\n}\n\n@media screen and (min-width: 1700px) {\n    .lastpara{\n        margin-top: 1px;\n    }\n}\n\n\n@media screen and (min-width: 1300px) {\n    .BodyPanel{\n        margin-left: 25px;\n    }\n}\n\n@media screen and (min-width: 1400px) {\n    .BodyPanel{\n        margin-left: 70px;\n    }\n}\n\n\n@media screen and (min-width: 1400px) {\n    .chartlist{\n        margin-left: 0px !important;\n    }\n}\n\n\n\n@media screen and (min-width: 1600px) {\n    .firstpara, .lastpara{\n        left: 180px !important;\n    }\n}\n\n\n\n@media screen and (min-width: 1500px) {\n    .BodyPanel{\n        align-items: center;\n        left: 150px;\n    }\n}\n\n@media screen and (min-width: 1600px) {\n    .BodyPanel{\n        left: 190px;\n    }\n}\n\n/* @media screen and (max-width: 1500px) {\n    .BodyPanel{\n        top: 1800px;\n    }\n} */\n\n@media screen and (min-width: 1700px) {\n    .BodyPanel{\n        align-items: center;\n        left: 265px;\n    }\n}\n\n@media screen and (min-width: 1300px) {\n    .firstpara, .lastpara{\n       margin-left: 2%;\n    }\n}\n\n@media screen and (min-width: 1700px) {\n    .firstpara, .lastpara{\n       margin-left: 7%;\n    }\n}\n\n@media screen and (min-width: 1900px) {\n    .firstpara, .lastpara{\n       margin-left: 11%;\n    }\n}\n\n\n@media screen and (min-width: 1900px) {\n    .BodyPanel{\n        align-items: center;\n        left: 355px;\n    }\n}\n\n@media screen and (min-width: 2000px) {\n    .BodyPanel{\n        left: 385px;\n    }\n}\n\n\n/* \n@media screen and (max-width: 1300px) {\n    .accordion-button, .accordion-body{\n        width: 700px;\n    }\n} */\n\n@media screen and (max-width: 1300px) {\n    .accordion-button, .accordion-body{\n        margin-left: 10px;\n    }\n}\n\n@media screen and (max-width: 1300px) {\n    .preview1 {\n        width: 92%;\n    }\n}\n\n@media screen and (max-width: 1300px) {\n    .accordion {\n        width: 900px;\n    }\n}\n\n@media screen and (max-width: 1300px) {\n      .second,canvas {\n        width: 27%;\n    }\n}\n\n@media screen and (max-width: 1300px) {\n    .first {\n      width: 100%;\n  }\n}\n\n@media screen and (max-width: 1300px) {\n    .second{\n      margin-left: 355px;\n   }\n}\n\n@media screen and (max-width: 1300px) {\n    .listheading{\n      left: 12px;\n   }\n}\n\n@media screen and (max-width: 1300px) {\n    .filesbody{\n      left: 10px;\n   }\n}\n\n@media screen and (max-width: 1300px) {\n    .previewnew{\n      width: 16%;\n   }\n}\n\n@media screen and (max-width: 1300px) {\n    .preview{\n      margin-left: 600px;\n      width: 200px;\n   }\n}\n\n@media screen and (max-width: 1300px) {\n    .third {\n       width: 27%;\n       margin-left: 140px;\n   }\n}\n\n @media screen and (min-width: 2101px) {\n    .third {\n       width: 29%;\n   }\n}\n\n@media screen and (min-width: 2101px) {\n    .second{\n      margin-left: 46%;\n      width: 29%;\n      position: absolute;\n      top: 415px;  \n   }\n}\n\n@media screen and (min-width: 2101px) {\n    .preview{\n      margin-left: 75%;\n      width: 18%;\n      top: 575px;\n   }\n}\n\n@media screen and (min-width: 2101px) {\n    .previewheading2{\n      margin-left: 35%;\n   }\n}\n\n@media screen and (min-width: 2101px) {\n    .resultsheading{\n      margin-left: 85%;\n   }\n}\n\n\n@media screen and (min-width: 2101px) {\n    .BodyPanel{\n        max-width: 60%;\n       margin-left: 3.6% !important;\n    }\n}\n\n@media screen and (min-width: 1500px) {\n    .BodyPanel{\n       margin-left: 2% !important;\n    }\n}\n\n@media screen and (min-width: 1800px) {\n    .BodyPanel{\n        margin-left: 3% !important;\n    }\n}\n\n\n@media screen and (min-width: 2301px) {\n    .BodyPanel{\n      \n       margin-left: 4.2% !important;\n    }\n}\n\n@media screen and (min-width: 2101px) {\n    .preview1 {\n        width: 95%;\n    }\n}\n\n@media screen and (min-width: 2101px) {\n    .first{\n        width: 100%;\n    }\n}\n\n@media screen and (min-width: 2101px) {\n    .uploadfile{\n        width: 95%;\n    }\n} \n\n@media screen and (min-width: 1300px) {\n    .chartlist{\n        margin-left: -30px;\n    }\n}\n\n\n@media screen and (max-width: 1300px) {\n    .chartlist{\n        margin-left: 50px;\n    }\n} \n\n@media screen and (min-width: 1500px) {\n    .chartlist{\n        margin-left: 1% !important;\n    }\n} \n\n@media screen and (min-width: 1600px) {\n    .chartlist{\n        margin-left: 3.5% !important;\n    }\n} \n\n\n@media screen and (min-width: 1700px) {\n    .chartlist{\n        margin-left: 9% !important;\n    }\n} \n\n\n\n@media screen and (min-width: 1900px) {\n    .chartlist{\n        margin-left: 250px !important;\n    }\n} \n\n\n@media screen and (min-width: 2101px) {\n    .chartlist{\n        margin-left: 13% !important;\n    }\n} \n\n@media screen and (max-width: 1100px) {\n    .chartlist{\n        margin-left: 0px;\n    }\n} \n\n@media screen and (max-width: 1300px) {\n    .accordion{\n        width: 900px !important;\n    }\n} \n\n\n@media screen and (max-width: 1100px) {\n    .accordion{\n        margin-left: 100px !important;\n    }\n} \n\n@media screen and (max-width: 1000px) {\n    .accordion{\n        margin-left: 100px !important;\n    }\n} \n\n@media screen and (max-width: 1000px) {\n    .accordion, .chartlist{\n        margin-left: 20px !important;\n    }\n} \n\n@media screen and (max-width: 880px) {\n    .accordion{\n        margin-left: 0px !important;\n    }\n} \n\n@media screen and (max-width: 750px) {\n    .pagetitle{\n        margin-top: 250px;\n        margin-left: 350px;\n    }\n} \n\n@media screen and (max-width: 750px) {\n    .chartlist{\n        left: 7px;\n    }\n} \n\n@media screen and (max-width: 750px) {\n    .firstpara, .thirdpara, .lastpara{\n        margin-left: 40px;\n    }\n} \n\n@media screen and (max-width: 750px) {\n    .stpimg{\n        margin-left: 100px;\n    }\n} \n\n@media screen and (max-width: 700px) {\n    .pagetitle{\n        margin-top: 250px;\n        margin-left: 380px;\n    }\n} \n\n@media screen and (max-width: 700px) {\n    .chartlist{\n        left: 10px;\n    }\n} \n\n@media screen and (max-width: 700px) {\n    .firstpara, .thirdpara, .lastpara{\n        margin-left: 90px;\n    }\n} \n\n@media screen and (max-width: 700px) {\n    .stpimg{\n        margin-left: 200px;\n    }\n} \n\n@media screen and (min-width: 1700px) {\n    .lastpara{\n        margin-top: 100px;\n    }\n} \n\n@media screen and (min-width: 1600px) {\n    .BodyPanel, .chartlist{\n        margin-left: 3%;\n    }\n}\n\n/* @media screen and (min-width: 1570px) {\n    .stpimg{\n      margin-top: -10px !important;\n    \n    }\n} */\n\n/* @media screen and (max-width: 1550px) {\n    .stpimg{\n        margin-top: 2% !important;\n    \n    }\n} */\n\n@media screen and (min-width: 1500px) {\n    .firstpara{\n        max-width: 1200px;\n    \n    }}\n\n\n\n.partidbutton {\n    width: 100px;\n    height: 40px;\n    float: left;\n    font-size: x-small;\n    padding-bottom: 10px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    border: 2px solid #D50C2F;\n    border-radius: 15px;\n    background-color: white;\n    margin-bottom: 5px;\n    margin-left: 30px;\n    padding-top: 10px;\n} \n\n.fileslist {\n    width: 100px;\n    float: left;\n    font-size: x-small;\n    padding-bottom: 10px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    border: 2px solid #D50C2F;\n    border-radius: 15px;\n    background-color: white;\n    margin-bottom: 5px;\n    padding-top: 10px;\n}\n\n.fileslist:hover {\n    cursor: pointer;\n    background-color: #D50C2F;\n    color: white;\n}\n\n\n.partidbutton4 {\n    width: 100px;\n    float: left;\n    font-size: x-small;\n    padding-bottom: 10px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    border: 2px solid #D50C2F;\n    border-radius: 15px;\n    background-color: #D50C2F;\n    margin-bottom: 5px;\n    margin-left: 5px;\n    padding-top: 10px;\n    color: white;\n} \n\n.partidbutton4:hover {\n    cursor: pointer;\n}\n\n.partidbutton3 {\n    width: 100px;\n    height: 40px;\n    float: left;\n    font-size: x-small;\n    padding-bottom: 10px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    border: 2px solid #D50C2F;\n    border-radius: 15px;\n    background-color: #D50C2F;\n    margin-bottom: 5px;\n    margin-left: 30px;\n    padding-top: 10px;\n    color: white;\n} \n\n.partidbutton3:hover {\n    cursor: pointer;\n}\n\n\n\n.partidbutton2 {\n    width: 100px;\n    height: 35px;\n    float: left;\n    font-size: xx-small;\n    padding-bottom: 10px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    border: none;\n    margin-bottom: 5px;\n    color: #D50C2F;\n} \n\n\n.partidbutton1 {\n    width: 60px;\n    height: 35px;\n    float: right;\n    font-size: xx-small;\n    padding-bottom: 10px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    border: 2px solid #D50C2F;\n    border-radius: 15px;\n    background-color: white;\n    margin-bottom: 5px;\n    position: relative;\n    left: -30px;\n} \n\n\n.sim {\n    position: relative;\n    left: -30px;\n}\n\ntable,  td {\n    align-items: center;\n    width: 131%;  \n}\n td {\n    padding-right: 20px;\n\n}\n\nsvg {\n    width: -webkit-fill-available;\n    height: 70px;\n    color: #D50C2F;\n}\n\n.accordion-item {\n    border-radius: 25px;\n}\n\n.accordion {\n    margin-top: 500px;\n    padding-bottom: 10px;\n    position: relative;\n    width: 1200px;\n    margin-left: 160px;\n}\n\n/* Style the buttons that are used to open and close the accordion panel */\n.accordion-button {\n    background-color: #D50C2F;\n    color: white;\n    cursor: pointer;\n    padding: 18px;\n    min-inline-size: -webkit-fill-available;\n    text-align: center;\n    border: none;\n    outline: none;\n    transition: 0.4s;\n    font-weight: bold;\n    border-radius: 10px;\n    position: relative;\n    z-index: 0;\n    font-size: large;\n  }\n  \n  /* Add a background color to the button if it is clicked on (add the .active class with JS), and when you move the mouse over it (hover) */\n  .active {\n    background-color: #c9c9c9;\n  }\n\n\n\n  .accordion-body {\n    padding-top: 40px;\n    margin-top: -45px;\n    background-color: white;\n    height: 600px;\n  }\n\n  \n  /* Style the accordion panel. Note: hidden by default */\n  .panel {\n    padding: 0 18px;\n    border: 1px solid;\n    display: none;\n    overflow: hidden;\n  }\n\n\n.calculationmethod {\n  border-radius: 5px;\n  height: 30px;\n  width: 145px;\n}\n\nbutton.partidbutton:active {\n    background-color: #D50C2F;\n    border-color: #D50C2F;\n    color: white;\n}\n\n.partidbutton:hover, .submitform:hover, .uploadfile:hover {\n    cursor: pointer;\n}\n\n\n.partidbutton:hover {\n   overflow-x: visible;\n    overflow-wrap: normal;\n    width: 200px;\n    margin-right: 25px;\n    border: none;\n    color: #D50C2F;\n    font-size: xx-small;\n    margin-left: -20px;\n}\n\n.uploadiconpopup1 {\n    margin-top: 15%;\n}\n\n.spacer {\n    height: 20px;\n}\n\n\n.stpimg {\n    width:45%;\n    flex-shrink: 0;\n    height: max-content;\n    \n}\n\n\n\n.lastpara {\n    background-color: white;\n    border-radius: 5px;\n    width: 80%;\n    left: 130px;\n    position: relative;\n   top: 50px;\n   text-align: justify;\n   padding: 20px;\n   font-size: larger;\n   z-index: 0;\n   max-width: 1200px;\n}\n\n.listheading {\n  position: absolute;\n margin-left: 27px;\n padding-bottom: 20px;\n}\n\n.filesbody {\n    top: 50px;\n    position: absolute;\n}\n/* \n.chartlist {\n    background-color: white;\n    width: 1200px;\n    margin-left: 180px;\n    height: 1200px;\n    border-radius: 25px;\n} */\n\n.chartlist {\n    margin-top: 650px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
